import React from 'react';

// Define the props for the CustomLabel component
interface CustomLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  // Custom prop to specify font size and leading space
  required?: boolean;
  size?: 16 | 14; // Default to 16, but can be 14
  htmlFor?: string; // Required prop to associate label with a form element
}

const CustomLabel: React.FC<CustomLabelProps> = ({ size = 16, children, className, required, htmlFor, ...props }) => {
  // Combine the default class with any additional classes passed as props
  const combinedClasses = `font-[400] !text-[#727A8BCC] ${size === 16 ? "text-[16px] leading-[24px]" : "text-[14px] leading-[22px]"} ${className || ''}`;

  return (
    <label htmlFor={htmlFor} className={combinedClasses} {...props}>
      {children} {required && <span className='text-red-500'>*</span>}
    </label>
  );
};

export default CustomLabel;
